import { AxiosResponse } from "axios";
import axiosInstance from "./axiosInstance";

export const search = (paramFilter: object, paginationInfo: System.PaginationInfo): Promise<AxiosResponse<any>> => {
  return axiosInstance.get("/publications/search", {
    params: {
      filters: paramFilter,
    paginationInfo: paginationInfo
    }
  });
};

export const searchPublicationById = (id: number): Promise<AxiosResponse<any>> => {
  return axiosInstance.get("/publications/searchById", {
    params:{
      id: id
    }
  });
}

export const updatePublication = (publication: System.Publication): Promise<AxiosResponse<any>> => {
  return axiosInstance.post('/publications/update',{publication:publication});
}

export const deletePublication = (params: object): Promise<AxiosResponse<any>> => {
  return axiosInstance.delete('/publications/delete',{data:params});
}

//TO DO : separate put, delete, post
export const createPublication = (publication: System.Publication): Promise<AxiosResponse<any>> => {
  console.log('sending publication:');
  console.log(publication);
  return axiosInstance.post('/publications/create',{publication: publication});
}